import { services } from '../services';
var action = "report/";

export const incomeExpenseReportService = {
    getIncomeExpense,
    getSaleDetail,
    getSaleUnit,
    getIncomeDaily,
    getExpenseDaily,
    getIncomeSummary
};

function getIncomeExpense(object="", param = 'incomeexpense') {
    return services.restApi(`${action}${param}${object}`, 'GET');
}

function getSaleDetail(object='', param = 'sale-detail') {
    return services.restApi(`${action}${param}${object}`, 'GET');
}

function getSaleUnit(object='', param = 'sale-unit') {
    return services.restApi(`${action}${param}${object}`, 'GET');
}

function getIncomeDaily(param = '', uri = 'report/income/daily') {
    return services.restApi(`${uri}${param}`, 'GET');
}

function getExpenseDaily(param='') {
    let uri = 'report/expense/daily';
    return services.restApi(`${uri}${param}`, 'GET');
}
function getIncomeSummary(param='') {
    let uri = 'report/income/summary';
    return services.restApi(`${uri}${param}`, 'GET');
}

